import { useLocation } from 'react-router-dom';

export enum URLParams {
  UID = 'uid',
  FORM_UID = 'formUid',
  PRIMARY_ORG_UID = 'primaryEngagement.primaryOrg.uid',
  PRIMARY_ORG_NAME = 'primaryEngagement.primaryOrg.name'
}

export function useUrlQuery() {
  return new URLSearchParams(useLocation().search);
}

export default useUrlQuery;
